import { useState, useEffect, useMemo } from 'react';

import { RESPONSIVE_BREAKPOINTS } from '../../../Domain/Settings/Constants/BreakPoints/BreakPoints';
import { useMediaQuery } from './UseMediaQuery';

// Separator group value according to the screen width

// Custom hook for slicing content according to the width of the screen
export const UseSliceContentBreakpoint = (
  contentList = [],
  breakpointContentFixed = false,
  breakpointContent = {},
  breakpointCallback = null,
  changePoint = false
) => {
  const BREAKPOINTS_CONTENT = {
    MD: 1,
    LG: 2,
    XL: changePoint ? changePoint : 2
  };
  // Reference to screen changes values hook
  const [width] = useMediaQuery();
  // At this point, we haven't calculated the content per group value
  const [contentPerGroup, setContentPerGroup] = useState(RESPONSIVE_BREAKPOINTS.MD);

  // Calculate contentPerGroup based on screen width and user-defined settings
  useEffect(() => {
    if (breakpointContentFixed) {
      setContentPerGroup(breakpointContentFixed);
      return;
    }

    // Execute and set the custom user handler
    if (breakpointCallback) {
      const groupLength = breakpointCallback(width);
      // Prevent incorrect values
      if (typeof groupLength === 'number' && groupLength >= 1) {
        setContentPerGroup(groupLength);
      }
      return;
    }

    // Validate the user breakpoints content
    const isValidUserBreakpointContent = ['MD', 'LG', 'XL'].every((breakpoint) =>
      Object.keys(breakpointContent).includes(breakpoint)
    );

    // Use the user breakpoints content if valid
    if (isValidUserBreakpointContent) {
      setContentPerGroup(
        width <= RESPONSIVE_BREAKPOINTS.MD
          ? breakpointContent.MD
          : width <= RESPONSIVE_BREAKPOINTS.LG
          ? breakpointContent.LG
          : breakpointContent.XL
      );
      return;
    }

    // Use the default breakpoints content
    setContentPerGroup(
      width <= RESPONSIVE_BREAKPOINTS.MD
        ? BREAKPOINTS_CONTENT.MD
        : width <= RESPONSIVE_BREAKPOINTS.LG
        ? BREAKPOINTS_CONTENT.LG
        : BREAKPOINTS_CONTENT.XL
    );
  }, [width, breakpointContentFixed, breakpointContent, breakpointCallback]);

  // Calculate slicedContentList using useMemo to avoid unnecessary recalculations
  const slicedContentList = useMemo(() => {
    const newSlicedContentList = [];
    for (let i = 0; i < contentList.length; i += contentPerGroup) {
      newSlicedContentList.push(contentList.slice(i, i + contentPerGroup));
    }
    return newSlicedContentList;
  }, [contentList, contentPerGroup]);

  return {
    slicedContentList,
    contentPerGroup
  };
};
